export const Section = ({ id, children, className = "", testid }) => (
  <section
    id={id}
    data-testid={testid || `section-${id}`}
    className={`relative ${className}`}
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10">{children}</div>
  </section>
);

export const Overline = ({ children, invert = false }) => (
  <span
    className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-[0.16em] ${
      invert
        ? "bg-white/20 backdrop-blur text-white border border-white/30"
        : "bg-[#12DDB5]/12 text-[#0b9a7c]"
    }`}
  >
    {children}
  </span>
);

export const H2 = ({ children, highlight, invert = false }) => (
  <h2
    className={`mt-4 text-3xl sm:text-4xl lg:text-[2.5rem] font-extrabold tracking-[-0.02em] leading-[1.1] ${
      invert ? "text-white" : "text-[#1F2937]"
    }`}
  >
    {children}{" "}
    {highlight && (
      <span className={invert ? "text-[#73F2B3]" : "text-gradient-brand"}>
        {highlight}
      </span>
    )}
  </h2>
);
